import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getRows = store => store[NAME].rows;
export const getInstances = store => store[NAME].instances;
export const getDateFormat = store => store[NAME].dateFormat;
